/**
 * @param {string} name
 * @param {any} value
 */
export function setValue (name, value) {
  localStorage.setItem(name, JSON.stringify(value));
}

/**
 * @param {string} name
 */
export function getValue (name) {
  const value = localStorage.getItem(name);

  if (!value) {
    return null;
  }

  return JSON.parse(value);
}

export function resetToolHints () {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key.startsWith('gisw')) {
      setValue(key, null);
    }
  }
}
